var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"check-users-item-operation",style:(_vm.itemStyle),on:{"click":_vm.removeMember}},[_c('span',{staticClass:"operation"},[_vm._v("-")]),_vm._v(" "),_c('span',[_vm._v("移出")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d1f4e19","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/im/team/CheckUserItemRemove.vue
// module id = null
// module chunks = 